import AutocadLogo from '../../assets/Logo/autocad.webp';
import CadmateLogo from '../../assets/Logo/cadmate.webp';
import GstarcadLogo from '../../assets/Logo/gstarcad.webp';
import BricscadLogo from '../../assets/Logo/bricscad.webp';
import ZwcadLogo from '../../assets/Logo/zwcad.webp';
import ProgecadLogo from '../../assets/Logo/progecad.webp';

// Lifted to module scope and exported so the platform picker can render the
// same logos rather than keeping a second copy of this mapping. `name` is the
// existing all-caps label the tables use; `shortName` is the cased form for
// places that read as prose rather than as a data cell.
export const PRODUCT_DATA = {
  SPCAD_ACAD_Beta: { logo: AutocadLogo, name: "AUTOCAD", shortName: "AutoCAD" },
  SPCAD_CADMATE: { logo: CadmateLogo, name: "CADMATE", shortName: "Cadmate" },
  SPCAD_GSTARCAD: { logo: GstarcadLogo, name: "GSTARCAD", shortName: "GstarCAD" },
  SPCAD_BRX: { logo: BricscadLogo, name: "BRICSCAD", shortName: "BricsCAD" },
  SPCAD_ZWCAD: { logo: ZwcadLogo, name: "ZWCAD", shortName: "ZWCAD" },
  SPCAD_PCAD: { logo: ProgecadLogo, name: "ProgeCAD", shortName: "ProgeCAD" },
};

export default function MapProduct(product, type) {
  if (!product) return "-";

  const productData = PRODUCT_DATA;

  const selected = productData[product];
  if (!selected) return product;

  // Plain-text label (e.g. for <option> elements that can't render JSX).
  if (type === "text") return selected.name;

  const imageStyle = {
    width: "22px",
    height: "auto",
    maxWidth: "22px",
    maxHeight: "22px",
    objectFit: "contain",
    display: "block",
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "6px",
  };

  const textStyle = {
    marginLeft: "6px",
    whiteSpace: "normal",
    wordWrap: "break-word",
  };

  const label =
    type === "simple"
      ? selected.name
      : `SPCAD for ${selected.name.charAt(0)}${selected.name.slice(1).toLowerCase()}`;

  return (
    <div style={containerStyle}>
      <img src={selected.logo} alt={`${label} Logo`} style={imageStyle} />
      <span style={textStyle}>{label}</span>
    </div>
  );
}
